<template>
  <div class="d-flex dashboard-layout">
    <!-- Navbar lateral
    ----------------------->
    <div
      v-if="isDrawerOpen"
      class="sidebar-backdrop d-md-none"
      aria-hidden="true"
      @click="closeMobileDrawer"
    ></div>
    <nav class="navbar navbar-dark align-items-start sidebar sidebar-dark bg-somosierra p-0" :class="{
      toggled: isToggledSidebar,
      'sidebar-mode-icons': isIconsMode,
    }">
      <div class="d-flex flex-column w-100 px-2" :class="isIconsMode ? 'pt-1' : 'pt-2'">
        <div v-if="!isIconsMode" class="d-flex align-items-start sidebar-brand-row">
          <div
            class="navbar-brand d-flex justify-content-center align-items-center sidebar-brand m-0 sidebar-brand-title flex-grow-1"
            role="presentation">
            <div class="sidebar-brand-text mx-4 text-white">
              <span>Technology<br> Operations</span>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-link text-white d-md-none sidebar-close-mobile p-2"
            aria-label="Cerrar menú"
            @click="closeMobileDrawer"
          >
            <i class="fas fa-times fa-lg" aria-hidden="true"></i>
          </button>
        </div>
        <hr v-if="!isIconsMode" class="sidebar-divider my-2">
        <ul id="accordionSidebar" class="nav navbar-nav text-light listaDashboard"
          :key="isIconsMode ? 'sidebar-icons' : 'sidebar-expanded'">
          <li v-if="menusIncidencias.redIt" class="nav-item text-white" :class="{ 'nav-item-current': $route.name === 'cuadroMando' }"
            role="presentation" v-on:click.prevent="carga('cuadroMando')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'cuadroMando' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip($t('alarms')) : false">
              <i class="fas fa-bell text-white pr-1"></i>
              <span class="pl-1 text-white">{{ $t('alarms') }}</span>
            </a>
          </li>
          <li v-if="menusIncidencias.red" class="nav-item text-white" :class="{ 'nav-item-current': $route.name === 'cuadroMandoRed' }"
            role="presentation" v-on:click.prevent="carga('cuadroMandoRed')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'cuadroMandoRed' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip($t('alarmsNetwork')) : false">
              <i class="fas fa-network-wired text-white pr-1"></i>
              <span class="text-white">{{ $t('alarmsNetwork') }}</span>
            </a>
          </li>
          <li v-if="menusIncidencias.it" class="nav-item text-white" :class="{ 'nav-item-current': $route.name === 'cuadroMandoIT' }"
            role="presentation" v-on:click.prevent="carga('cuadroMandoIT')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'cuadroMandoIT' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip($t('alarmsIT')) : false">
              <i class="fas fa-server text-white pr-1"></i>
              <span class="pl-1 text-white">{{ $t('alarmsIT') }}</span>
            </a>
          </li>

          <!-- ================================= Enviar ================================= -->

          <li v-if="this.tienePermisoEnvio" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'envioSms' }" role="presentation"
            v-on:click.prevent="carga('envioSms')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'envioSms' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Enviar comunicación') : false">
              <i class="fas fa-comment text-white pr-1"></i>
              <span class="pl-1 text-white">Enviar comunicación</span>
            </a>
          </li>
          <li v-if="this.tienePermisoListas" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'listasDestinatarios' }" role="presentation"
            v-on:click.prevent="carga('listasDestinatarios')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'listasDestinatarios' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Listas destinatarios') : false">
              <i class="fas fa-address-book text-white pr-1"></i>
              <span class="pl-1 text-white">Listas destinatarios</span>
            </a>
          </li>

          <!-- ================================= suscripción ================================= -->

          <li class="nav-item text-white" :class="{ 'nav-item-current': $route.name === 'subscripcion' }"
            role="presentation" v-on:click.prevent="carga('subscripcion')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'subscripcion' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip(estaSuscripto ? 'Alta en broadcast' : 'Gestión broadcast') : false">
              <i :class="estaSuscripto ? 'fas fa-user-plus text-white pr-1' : 'fas fa-user-cog text-white pr-1'"></i>
              <span class="pl-1 text-white">{{ estaSuscripto ? 'Alta en broadcast' : 'Gestión broadcast' }}</span>
            </a>
          </li>

          <!-- ================================= subscripciones ================================= -->

          <li v-if="this.padmin" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'subscripciones' }" role="presentation"
            v-on:click.prevent="carga('subscripciones')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'subscripciones' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Suscripciones Broadcast') : false">
              <i class="fas fa-users-cog text-white pr-1"></i>
              <span class="pl-1 text-white">Suscripciones Broadcast</span>
            </a>
          </li>

          <!-- ================================= gestion de usuarios ================================= -->

          <li v-if="this.padmin" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'permisosUser' }" role="presentation"
            v-on:click.prevent="carga('permisosUser')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'permisosUser' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip($t('dashboardUsers')) : false">
              <i class="fas fa-edit text-white pr-1"></i>
              <span class="pl-1 text-white">{{ $t('dashboardUsers') }}</span>
            </a>
          </li>

          <!-- ================================= Panel de Errores ================================= -->

          <li v-if="this.permisosErrores" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'panelErrores' }" role="presentation"
            v-on:click.prevent="carga('panelErrores')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'panelErrores' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Panel de errores') : false">
              <i class="fas fa-exclamation-triangle text-white pr-1"></i>
              <span class="pl-1 text-white">Panel de errores</span>
            </a>
          </li>

          <li class="nav-item text-white" :class="{ 'nav-item-current': $route.name === 'buscadorIncidencias' }"
            role="presentation" v-on:click.prevent="carga('buscadorIncidencias')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'buscadorIncidencias' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Buscador incidencias') : false">
              <i class="fas fa-search text-white pr-1"></i>
              <span class="pl-1 text-white">Buscador incidencias</span>
            </a>
          </li>

          <!-- ================================= Papelera de reciclaje ================================= -->

          <li v-if="this.peditor" class="nav-item text-white"
            :class="{ 'nav-item-current': $route.name === 'trashBin' }" role="presentation"
            v-on:click.prevent="carga('trashBin')">
            <a class="nav-link cursor-pointer text-dark" :class="{ active: $route.name === 'trashBin' }"
              v-b-tooltip.body.hover.right="isIconsMode ? navTooltip('Papelera') : false">
              <i class="fas fa-trash text-white pr-1"></i>
              <span class="pl-1 text-white">Papelera</span>
            </a>
          </li>
        </ul>
        <!-- El botón que colapsa la barra lateral-->
        <div class="text-center d-none d-md-block sidebar-collapse-control">
          <button id="sidebarToggle" class="rounded-circle border-0 sidebarToggle text-dark"></button>
        </div>

      </div>
      <!-- Texto al final de la barra lateral -->
      <div class="sidebar-footer pb-2 mt-auto text-white text-center">
        {{ sidebarFooterLabel }}
      </div>
    </nav>
    <!-- Contenedor principal
    ----------------------->
    <div class="container-fluid px-1">
      <nav class="navbar navbar-light navbar-expand bg-white shadow mb-4 topbar static-top">
        <div class="container-fluid px-0 ">
          <!-- El bocadillo que aparece cuando colapsas la barra lateral-->
          <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3 sidebarToggle" type="button">
            <i class="fas fa-bars"></i>
          </button>
          <span v-if="this.peditor && this.$store.state.botonEditar" class="p-2 mx-1">{{ $t('Edit') }}</span>
          <div v-if="this.peditor && this.$store.state.botonEditar" class="toggle-container">
            <button id="toggle" :class="{ active: this.$store.state.editar }" class="toggle-button"
              v-on:click="ChangeEd()"></button>
          </div>
          <div class="ml-2">

            <!-- Botón visible solo en pantallas grandes (lg y mayores) -->
            <BButton v-if="mostrarBoton" class="m-1 d-none d-lg-inline"
              :variant="$store.state.resumenAbierto ? 'success' : 'secondary'" @click="$store.commit('toggleResumen')">
              Mostrar/Ocultar Resumen
            </BButton>
          </div>
          <div :class="{ 'alert-box-active': this.$store.state.editar }" class="p-3 mx-5 alert-box ocultar-movil">
            <span> {{ $t('UpdateAlarmRemember') }}</span>
          </div>
          <ul class="nav navbar-nav flex-nowrap ml-auto">
            <div class="d-none d-md-block topbar-divider"></div>
            <li class="d-none d-md-block nav-item mx-4 d-flex align-items-center">
              <b-img alt="Logo Orange" class="topbar-logo" src="../assets/orange-logo-small.png" />
            </li>
            <div class="d-none d-sm-block topbar-divider"></div>
            <li class="nav-item dropdown no-arrow" role="presentation">
              <div class="nav-item dropdown no-arrow">
                <a aria-expanded="false" class="dropdown-toggle nav-link" data-toggle="dropdown" href="#">
                  <span class="d-none d-lg-inline mr-2 text-dark small">{{ nombreUsr }}</span>
                  <b-img class="border rounded-circle img-profile" src="../assets/defaultAvatar.png" />
                </a>
              </div>
            </li>
            <div class="d-none d-sm-block topbar-divider"></div>
            <li class="nav-item dropdown no-arrow text-black" role="presentation">
              <div class="nav-item dropdown no-arrow">
                <a aria-expanded="false" class="dropdown-toggle nav-link" data-toggle="dropdown" href="#"
                  v-on:click.prevent="sigOutSOO()">
                  <i class="fas fa-power-off fa-2x"></i>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <div class="container-fluid">
        <div class="row">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../auth.js';
import * as $ from 'jquery';
import packageJson from '../../../package.json';
import { signOut } from '../authRedirect.js';
import { BButton } from "bootstrap-vue-next";
import {
  isDesktopPresentation,
  isSidebarToggled,
  modeOnLoad,
  modeOnResize,
  togglePresentationMode,
} from '../sidebarPresentationMode.js';
const { name, version } = packageJson;

export default {
  components: { BButton },
  data() {
    return {
      version_project: version,
      name_project: name,
      nombreUsr: '',
      apellidosUsr: '',
      foto: '',
      logged: false,
      conjuntoIdiomas: [
        { value: null, text: 'Please select language' },
        { value: 'en', text: 'English' },
        { value: 'es', text: 'Spanish' }
      ],
      idioma: null,
      isEditing: false,
      peditor: 0,
      padmin: 0,
      tienePermisoEnvio: false,
      tienePermisoListas: false,
      permisosErrores: 0,
      menusIncidencias: { redIt: false, red: false, it: false },
      presentationMode: 'expanded',
    }
  },
  computed: {
    mostrarBoton() {
      return this.$route.path === '/cuadroMando' && this.$store.state.veResumen;
    },
    estaSuscripto() {
      const estado = this.$store.state.estadoBroadcast || 'UNSUBSCRIBED';
      return estado === 'UNSUBSCRIBED';
    },
    isIconsMode() {
      return this.presentationMode === 'icons';
    },
    isToggledSidebar() {
      return isSidebarToggled(this.presentationMode);
    },
    isDrawerOpen() {
      return this.presentationMode === 'drawerOpen';
    },
    sidebarFooterLabel() {
      return this.isIconsMode
        ? `v${this.version_project}`
        : `${this.name_project} v${this.version_project}`;
    }
  },

  created() {
    // con esta parte revisamos si tenemos un token guardado y por lo tanto si estamos conectados. Habría que revisar que el token no ha expirado.
    if (localStorage.getItem('id_token')) {
      this.nombreUsr = localStorage.getItem('nombreUsr');
      this.comprobarEstadoBroadcast();
    }
  },
  mounted() {
    this.consultarPermisos();
    this.applyPresentationMode(modeOnLoad($(window).width()));

    $('.sidebarToggle').on('click', () => {
      this.applyPresentationMode(togglePresentationMode(this.presentationMode));
    });

    this.onSidebarViewportResize = () => {
      const next = modeOnResize($(window).width());
      // Reapply load rule only when crossing desktop ↔ mobile so an open
      // mobile drawer is not slammed shut by in-band viewport noise.
      if (isDesktopPresentation(this.presentationMode) !== isDesktopPresentation(next)) {
        this.applyPresentationMode(next);
      }
    };
    $(window).on('resize', this.onSidebarViewportResize);
  },
  beforeUnmount() {
    $('.sidebarToggle').off('click');
    $(window).off('resize', this.onSidebarViewportResize);
  },
  methods: {
    applyPresentationMode(mode) {
      this.presentationMode = mode;
      const toggled = isSidebarToggled(mode);
      $('body').toggleClass('sidebar-toggled', toggled);
      $('.sidebar').toggleClass('toggled', toggled);
      if (toggled) {
        $('.sidebar .collapse').addClass('hide');
      } else {
        $('.sidebar .collapse').removeClass('hide');
      }
    },
    closeMobileDrawer() {
      if (this.presentationMode === 'drawerOpen') {
        this.applyPresentationMode('drawerClosed');
      }
    },
    navTooltip(title) {
      return {
        title,
        placement: 'right',
        customClass: 'tooltip-ancho',
        delay: { show: 100, hide: 0 },
      };
    },
    carga(destino) {
      this.$store.state.editar = false;
      this.closeMobileDrawer();
      this.$router.push({ name: destino })
        .catch(error => {
        });
    },
    sigOutSOO() {
      // Desconectamos de SSO de MS
      signOut();
      localStorage.removeItem('id_token');
      localStorage.removeItem('nombreUsr');
    },
    desconecta() {
      localStorage.removeItem('id_token');
      localStorage.removeItem('apellidosUsr');
      localStorage.removeItem('nombreUsr');
      localStorage.removeItem('foto');
      window.location.href = "/";
    },
    cambiarIdioma() {
      this.$i18n.locale = this.idioma
    },
    ChangeEd() {
      this.isEditing = !this.isEditing;
      const editar = !(this.$store.state.editar);
      this.$store.state.editar = editar;
    },
    async consultarPermisos() {
      try {
        const response = await fetch('api/permisos', {
          method: 'GET',
          headers: auth.getAuthHeader()
        }
        );
        const data = await response.json();
        this.peditor = (data[0].editor === 1);
        this.padmin = (data[0].admin === 1);
        this.permisosErrores = (data[0].consultor_errores === 1);
        const menus = data[0].menus || {};
        this.tienePermisoEnvio = Boolean(menus.envio);
        this.tienePermisoListas = Boolean(menus.listas);
        this.menusIncidencias = {
          redIt: Boolean(menus.redIt),
          red: Boolean(menus.red),
          it: Boolean(menus.it),
        };
        this.$store.state.veResumen = Boolean(data[0].resumen);
      } catch (error) {
        console.error('Error al realizar la consulta de permisos', error);
      }
    },
    async comprobarEstadoBroadcast() {
      try {
        const email = encodeURIComponent(localStorage.getItem('userEmail'));
        if (!email || email === 'null') return;

        const response = await fetch(`/api/users/status?email=${email}`, {
          headers: auth.getAuthHeader()
        });

        if (response.ok) {
          const result = await response.json();
          const estado = (result.estado || 'UNSUBSCRIBED').trim().toUpperCase();

          // NUEVO: Guardamos en el Store de Vuex
          this.$store.state.estadoBroadcast = estado;
        }
      } catch (error) {
        console.error('Error al comprobar el estado', error);
      }
    }
  }
}
</script>

<style scoped>
.topbar-logo {
  display: block;
  height: 2rem;
  width: auto;
  max-height: 2rem;
  object-fit: contain;
}

.dashboard-layout {
  width: 100%;
  margin: 0;
  padding: 0;
}

.dashboard-layout>.sidebar {
  margin-left: 0;
  flex-shrink: 0;
  align-self: flex-start;
  position: sticky;
  top: 0;
  height: 100vh;
  max-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.dashboard-layout>.sidebar>.d-flex.flex-column {
  flex: 1 1 auto;
  min-height: 0;
}

.dashboard-layout>.sidebar>.sidebar-footer {
  flex-shrink: 0;
  margin-top: auto;
}

.dashboard-layout>.container-fluid {
  flex: 1 1 0%;
  min-width: 0;
}

.sidebar-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1035;
  background: rgba(0, 0, 0, 0.4);
}

.sidebar-close-mobile {
  flex-shrink: 0;
  line-height: 1;
  text-decoration: none;
}

.sidebar-close-mobile:hover,
.sidebar-close-mobile:focus {
  color: #fff8ee;
  text-decoration: none;
}

/* Mobile: drawer overlays content instead of pushing the flex layout. */
@media (max-width: 767.98px) {
  .dashboard-layout>.sidebar {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1040;
  }

  .dashboard-layout>.container-fluid {
    width: 100%;
    max-width: 100%;
  }
}

.listaDashboard {
  width: 100%;
  min-width: 0;
}

.listaDashboard .nav-item {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border-radius: 0.375rem;
  transition: background-color 0.2s ease;
}

.listaDashboard .nav-item-current .nav-link {
  background-color: rgba(0, 0, 0, 0.18);
  border-radius: 0.375rem;
}

.listaDashboard .nav-item-current .nav-link span,
.listaDashboard .nav-item-current .nav-link i {
  color: #fff8ee !important;
  font-weight: 600;
}
</style>

<style>
/* Misma clase que Cuadro de Mando; sin scoped porque el tooltip se monta en body. */
.tooltip-ancho .tooltip-inner {
  max-width: 500px !important;
  text-align: left !important;
  width: max-content;
  white-space: pre-line;
  word-break: break-word;
}
</style>